import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import PostCard from '../../../components/Portal/PostCard';
import { portalTournamentAPI } from '../../../services/api';

/**
 * PortalRecapTab - Post-tournament recap posts from the TD.
 * Same layout as Activity but filtered to recap category.
 */
const PortalRecapTab = () => {
  const { tournamentId } = useParams();
  const { tournament } = useOutletContext();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecap = async () => {
      try {
        const res = await portalTournamentAPI.getRecap(tournamentId);
        setPosts(res.data?.data?.posts || []);
      } catch (err) {
        console.error('Failed to load recap:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchRecap();
  }, [tournamentId]);

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin h-6 w-6 border-4 border-green-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-3xl mb-2">&#127942;</div>
        <h3 className="font-medium text-gray-700 mb-1">Recap Coming Soon</h3>
        <p className="text-sm text-gray-500">
          Results and recap will be posted by your tournament director.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {posts.map((post) => (
        <PostCard key={post._id} post={post} />
      ))}
    </div>
  );
};

export default PortalRecapTab;
